import {UserMetadataModel} from '../../../models/api/userMetadataModel';
import {AppAction} from '../../appActions';
import {UserMetadataActionsEnum} from './userMetadataActions';

export function userMetadataReducer(state: UserMetadataModel, action: AppAction): UserMetadataModel {
  switch (action.type) {
    case UserMetadataActionsEnum.USER_METADATA_UPDATED:
      return action.payload;

    default:
      return state;
  }
}
